import React from 'react'
import HeaderMain from '../../../Compoents/HeaderMain';
import BreadcrumbArea from '../../../ShearOne/BreadcrumbArea';
import FooterWhite from '../../../Compoents/FooterWhite';
import { Link } from 'react-router-dom';

export const NotifyBodayCone = () => {
    const breadcrumbLinks = [       
        { path: '/', label: 'Home' },
        { label: 'Notified Body Transition Details', active: true }
      ];
      return (
        <>
        <HeaderMain/>
        <main>
       
       <BreadcrumbArea 
         title="Notified Body Transition Details" 
         backgroundImage="/assets/imgs/breadcrumb/page-header-1.png" 
         links={breadcrumbLinks} 
       />

<section className="service-details section-space">
  <div className="container">
    <div className="row flex-xl-row flex-column-reverse">
      <div className="col-xl-4">
        <div className="sidebar sidebar-rr-sticky">
          <div className="sidebar__widget-service mb-30">
            <Link to="/service">
              Medical Device Manufacturers <i className="fa-solid fa-plus"></i>
            </Link>
            <Link to="/pharmaceutical-details">
              Pharmaceutical & Biotech industry <i className="fa-solid fa-plus"></i>
            </Link>
            <Link to="/healthcare-details">
              Healthcare Providers <i className="fa-solid fa-plus"></i>
            </Link>
          </div>

          <div className="sidebar__widget-contact__service text-center">
            <h4 className="mb-25 title-animation text-capitalize">
              Are You ready to contact with us
            </h4>
            <p className="mb-20">
              <a href="tel:+86 19811976744">
                <i className="fa-solid fa-phone"></i>(+86) 19811976744
              </a>
            </p>

            <Link to="/contact-us#" className="rr-btn">
              <span className="btn-wrap">
                <span className="text-one">
                  Contact Us <i className="fa-solid fa-plus"></i>
                </span>
                <span className="text-two">
                  Contact Us <i className="fa-solid fa-plus"></i>
                </span>
              </span>
            </Link>
          </div>
        </div>
      </div>
      <div className="col-xl-8">
        <div className="service-details__content">
          <div className="service-details__content-media mb-20">
            <img
              src="./assets/imgs/service-details/service-details-1.jpg"
              className="img-fluid"
              alt="img not found"
            />
          </div>
          <h2 className="title-animation mb-20">Notified Body Transition</h2>

        <p className="mb-20">
          We offer a variety of solutions to efficiently manage transition projects. While each transition project is unique, our process remains consistent.
        </p>
        <h3 className="title-animation mb-20"> Medical Device Registration</h3>

<p className="mb-20">
Medical device registration involves obtaining regulatory approval to market a device in a specific region. This process ensures that the device meets safety, efficacy, and quality standards set by local authorities. Successful registration is crucial for legal market entry and ongoing compliance. 
</p>
        <h4 className="title-animation mb-15">
  How SQUARE MEDTECH Can Help in FDA Registration
</h4>
<ul className="mb-40">
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Regulatory Compliance Expertise
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Conducting a GAP analysis of your existing technical documentation.
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Assisting with planning the required documentation for new products or projects.
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Documentation Preparation and Update
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Providing support in creating all necessary technical documentation elements.
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Quality Management System (QMS) Integration
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Training and Support
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Cybersecurity and Software Documentation
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Post-Market Surveillance (PMS) and Vigilance Reporting
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Submission and Liaison with Regulatory Bodies
  </li>
</ul>

          <h3 className="title-animation mb-15"><i className="fa-solid fa-vial text-primary"></i> Medical Device Registration</h3>
          <p>
            Medical device registration involves obtaining regulatory approval to market a device in a specific region. This process ensures that the device meets safety, efficacy, and quality standards set by local authorities. Successful registration is crucial for legal market entry and ongoing compliance.
          </p>
          <h3 className="title-animation mb-20"><i className="fa-solid fa-vial text-primary"></i> FDA Registration</h3>
          <p className="mb-20">
            The increasing prevalence of software as a medical device (SaMD) or
            as part of a device, often incorporating AI, IoT, mobile apps, or
            telemedicine, is accompanied by evolving regulatory requirements and
            heightened information security concerns. These challenges
            necessitate a comprehensive approach to compliance and development.
          </p>

          <p className="mb-15">
            In the US, the regulatory framework for medical devices differs from
            that in Europe. Instead of Notified Bodies, the FDA (Food and Drug
            Administration) oversees the approval and regulation of medical
            devices (MD) and in vitro diagnostic (IVD) devices.
          </p>
          <h4 className="mb-15">Here is a detailed overview of the process:</h4>
          <h6 className="mb-10">1. Registration and Listing:</h6>
<ul className="mb-30">
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    <strong>Device Registration:</strong> All companies intending to market medical devices in the US must register their establishments with the FDA.
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    <strong>Device Listing:</strong> Companies must list their devices with the FDA, providing necessary details about each product.
  </li>
</ul>

<h6 className="mb-10">2. Establishment Registration:</h6>
<ul className="mb-30">
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    <strong>Owners and Operators:</strong> Owners or applicable operators of establishments involved in the production and distribution of medical devices must also register with the FDA.
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    <strong>Annual Renewal:</strong> Registration must be renewed annually, ensuring ongoing compliance.
  </li>
</ul>

<h6 className="mb-10">3. Documentation and Risk Classification:</h6>
<ul className="mb-30">
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    <strong>Risk Classes:</strong> Devices are classified into three risk categories:
    <ul>
      <li><span><i className="fa-solid fa-check"></i></span> <strong>Class I:</strong> Low risk</li>
      <li><span><i className="fa-solid fa-check"></i></span> <strong>Class II:</strong> Moderate risk</li>
      <li><span><i className="fa-solid fa-check"></i></span> <strong>Class III:</strong> High risk</li>
    </ul>
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    <strong>Product Codes:</strong> Each device is assigned a product code that corresponds to its intended use and risk classification.
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    <strong>Non-Classified Devices:</strong> Some devices do not fit into these classifications and require specific regulatory pathways.
  </li>
</ul>

<h6 className="mb-10">4. FDA Approval Processes:</h6>
<ul className="mb-30">
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    <strong>510(k) Clearance:</strong> The most common submission pathway for Class II devices, demonstrating substantial equivalence to a legally marketed device.
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    <strong>De Novo Classification:</strong> A pathway for novel devices that provide reasonable assurance of safety and effectiveness for Class I or II designation.
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    <strong>Premarket Approval (PMA):</strong> Required for Class III devices, involving rigorous evaluation of safety and effectiveness through clinical trials and extensive documentation.
  </li>
</ul>


          <h3 className="title-animation mb-15">SQUARE MEDTECH Expertise</h3>
          <p className="mb-30">
            The <strong>SQUARE MEDTECH</strong> team has in-depth knowledge and
            experience with the US FDA. We assist medical device manufacturers
            in achieving regulatory compliance and gaining market access
            efficiently.
          </p>

          <div className="row">
            <div className="col-lg-7">
              <div className="service-details__content-media-item service-details__content-media-item-1">
                <div className="service-details__content-media-item_img mb-10">
                  <img
                    src="./assets/imgs/service-details/service-details-2.jpg"
                    className="img-fluid"
                    alt="img not found"
                  />
                </div>
                <h4 className="title-animation mb-15">
                <i class="fa fa-circle-o text-danger"></i> Our Expertise in  FDA registration 
                </h4>
                <p>
                SQUARE MEDTECH excels in FDA registration, guiding medical devices through complex regulatory pathways. Our expertise includes 510(k) submissions, PMA, De Novo classification, and compliance with FDA regulations. We ensure accurate documentation, risk assessment, and efficient approvals, enabling seamless market entry with precision, reliability, and regulatory expertise.
                </p>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="service-details__content-media-item service-details__content-media-item-2">
                <div className="service-details__content-media-item_img mb-10">
                  <img
                    src="./assets/imgs/service-details/service-details-3.jpg"
                    className="img-fluid"
                    alt="img not found"
                  />
                </div>
                <h4 className="title-animation mb-15">
                <i class="fa fa-circle-o text-danger"></i> Why Choose Us for  FDA registration 
                </h4>
                <p>
                Choose SQUARE MEDTECH for FDA registration because of our expert guidance, streamlined process, compliance expertise, and commitment to ensuring your products meet FDA requirements efficiently and effectively.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
    </main>


    <section class="footer__cta footer__cta-bottom-up">
    <div class="container">
        <div class="row mb-minus-30">
            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-primary d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-1.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                        <h4 class="color-white mb-15 mb-10">Our Service for Product Registration</h4>
                        <ul  class="color-white mb-0">
                        <li>Post Market Activities</li>
                        <li>Technical Documentation</li>
                        <li> Quality Management System</li>

                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-glow d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-2.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                        <h4 class="color-white mb-15 mb-10">Our Service for Product Registration</h4>
                        <ul  class="color-white mb-0">
                        <li> QA / RA Service</li>
                        <li>Product Registrations </li>
                        <li> Digital Health Services</li>
                      </ul>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


    <FooterWhite/>

    </>
  )
}
